import { computed } from 'vue'
import { BlockTypes, richTextResolver } from '@storyblok/richtext'
import { useCurrentShop } from '#storefront/composables'
import type { Sbrichtext } from '~/cms/storyblok/types/storyblok.d.ts'

const resolver = richTextResolver({
  resolvers: {
    [BlockTypes.EMOJI]: (node: { attrs?: { emoji?: string } }) => {
      return `<span class="emoji">${node.attrs?.emoji || ''}</span>`
    },
  },
})

const useRichtext = (body: Sbrichtext | undefined) => {
  const currentShop = useCurrentShop()
  const locale = currentShop.value?.locale

  return {
    content: computed(() => {
      if (!body) return null

      // Render HTML using the new resolver
      const html = resolver.render(body as any) as string

      const localeRegex =
        /href="(de|at|ch|fr-ch|fr-be|fr|be|nl|fi)\/([^'"\s>]+)/gi

      const strippedHtml = html?.replace(localeRegex, (_match, _lang, url) => {
        return `href="${url}"`
      })

      return strippedHtml?.replace(
        /href="\/?(?!http:|https:|mailto:|tel:|fax:)(\w+)/g,
        `href="/${locale}/$1`,
      )
    }),
  }
}

export default useRichtext
